// App 分享页路由白名单（hash 中的路径，不含 # 和 query），命中时不做域名重定向；后续新增分享页直接追加
export const APP_SHARE_ROUTE_WHITE_LIST: string[] = [
  'pages/invite/invitee',
  'pages/invite/friend',
  'pages/invite/rule',
  'pages/invite/detail',
  'pages/invite/reward',
  'pages/invite/poster',
]
